module.exports = __webpack_public_path__ + "img/banner.30dbfcc4.jpg";